import { MorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMemo, type PropsWithChildren } from "react";
import { MorphemeMnemonicsMeaningViewContext } from "#morpheme-mnemonics-meaning-view-context";

export function MorphemeMnemonicsMeaningViewContextProvider({
  children,
  openCompoundsSheet,
  openMnemonicUsagesSheet,
}: PropsWithChildren<{
  openCompoundsSheet: () => void;
  openMnemonicUsagesSheet: () => void;
}>) {
  const [morphemeHrefObject] = useContextSelectors(
    MorphemePanelsContext,
    (c) => c.morphemeHrefObject,
  );
  const value = useMemo(
    () => ({ morphemeHrefObject, openCompoundsSheet, openMnemonicUsagesSheet }),
    [morphemeHrefObject, openCompoundsSheet, openMnemonicUsagesSheet],
  );
  return (
    <MorphemeMnemonicsMeaningViewContext.Provider value={value}>
      {children}
    </MorphemeMnemonicsMeaningViewContext.Provider>
  );
}
